import { render, staticRenderFns } from "./ShowTicketView.vue?vue&type=template&id=dc19588a&scoped=true&"
import script from "./ShowTicketView.vue?vue&type=script&lang=js&"
export * from "./ShowTicketView.vue?vue&type=script&lang=js&"
import style0 from "./ShowTicketView.vue?vue&type=style&index=0&id=dc19588a&prod&lang=scss&scoped=true&"
import style1 from "./ShowTicketView.vue?vue&type=style&index=1&id=dc19588a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc19588a",
  null
  
)

export default component.exports